import { get } from 'lodash';
import Card from '@mui/material/Card';
import List from '@mui/material/List';
import PropTypes from 'prop-types';
import React, { useCallback, useState, useMemo } from 'react';
import { useQuery } from '@apollo/client';
import HTMLFragment from 'components/HTMLFragment';
import Image from 'components/Image';
import InfiniteScroller from 'components/InfiniteScroller';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ProgressCircle from 'components/ProgressCircle';
import Page from 'containers/Page';
import useIsMobile from 'lib/useIsMobile';
import { GET_ACTIVITIES } from '../schema/apolloQueries/activitiesQueries';

const styles = {
  card: {
    marginBottom: 10,
    cursor: 'pointer',
  },
};
const ActivitiesPage = ({
  router,
  // viewer
}) => {
  const mobile = useIsMobile();
  const { data } = useQuery(GET_ACTIVITIES, {
    variables: {
      mobileHero: false,
    },
  });

  const [viewer] = useState({
    loggedIn: false,
  });
  const getDataList = useMemo(() => {
    const eventList = [];
    const eventIdActivities = {};
    const eIdCmpldActivityCount = {};
    const totalCount = {};
    data?.getMyActivity?.forEach(ele => {
      if (!Object.prototype.hasOwnProperty.call(eventIdActivities, ele.eid)) {
        eventIdActivities[ele.eid] = [ele];
        eIdCmpldActivityCount[ele.eid] = 0;
        totalCount[ele.eid] = [];
        if (!ele.opt && !ele.alwaysOpen) {
          totalCount[ele.eid] = [ele];
          if (ele.status === 'COMPLETED' || ele.status === 'SUBMITTED') {
            eIdCmpldActivityCount[ele.eid] = 1;
          }
        }
      } else {
        const oldList = eventIdActivities[ele.eid];
        oldList.push(ele);
        if (!ele.opt && !ele.alwaysOpen) {
          const count = totalCount[ele.eid];
          count.push(ele);
          if (ele.status === 'COMPLETED' || ele.status === 'SUBMITTED') {
            const oldCount = eIdCmpldActivityCount[ele.eid];
            eIdCmpldActivityCount[ele.eid] = oldCount + 1;
          }
        }
      }
    });
    Object.keys(eventIdActivities).forEach(eventId => {
      const firstindex = eventIdActivities[eventId][0];
      const totalActivities = totalCount[eventId].length;
      const { eid, ename, heroPlaylist, eslug } = firstindex;
      eventList.push({
        ename,
        eid,
        eslug,
        heroPlaylist,
        totalActivities,
        completedActivities: eIdCmpldActivityCount[eventId],
        // activities: sorting(eventIdActivities[eventId]),
      });
    });
    return eventList;
  }, [data?.getMyActivity]);

  const getPercentage = (total, completed) => {
    let percenstage = 0;
    if (total !== 0 && completed !== 0) {
      percenstage = (completed / total) * 100;
    }
    return percenstage.toFixed();
  };
  return (
    <Page
      style={!mobile ? { paddingTop: 10 } : null}
      title='Activities'
      viewer={viewer}
    >
      <InfiniteScroller
        done
        empty={getDataList.length === 0}
        emptyText='Click here to find an event to participate in'
        emptyTitle="You aren't participating in any events right now!"
        onEmptyClick={useCallback(() => router.push('/discover/events'), [
          router,
        ])}
      // relay={relay}
      // pageSize={pageSize}
      // showDone={false}
      // varName='pageSize'
      >
        {getDataList?.map(event => {
          return (
            <Card key={event?.eid} style={styles.card}>
              <List>
                <ListItem
                  onClick={() => router.push(`/events/${event?.eslug}`)}
                >
                  <ListItemIcon style={{ width: 'min-content' }}>
                    <Image
                      src={get(event, 'heroPlaylist.assets[0].hlsPlaylistUrl')}
                      style={{
                        objectFit: 'contain',
                        width: '20%',
                        minWidth: 120,
                        margin: 10,
                      }}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={<HTMLFragment>{`${event?.ename}`}</HTMLFragment>}
                    sx={{
                      '& .MuiTypography-root': {
                        marginRight: '60px',
                      },
                    }}
                  />
                  <ListItemSecondaryAction>
                    <ProgressCircle
                      percentage={getPercentage(
                        event?.totalActivities,
                        event?.completedActivities,
                      )}
                      style={{
                        alignSelf: 'center',
                        marginRight: 10,
                        width: 80,
                        height: 80,
                      }}
                    />
                  </ListItemSecondaryAction>
                </ListItem>
              </List>
            </Card>
          );
        })}
      </InfiniteScroller>
    </Page>
  );
};

ActivitiesPage.propTypes = {
  router: PropTypes.object.isRequired,
  viewer: PropTypes.object.isRequired,
};

export default ActivitiesPage;
